const ar = {
  header: {
    about: 'حول',
    contact: 'اتصل',
    sign_in: 'تسجيل الدخول',
    dashboard: 'لوحة القيادة',
    biolink_page: 'صفحة بيولينك',
    admin: 'مسؤل',
    logout: 'تسجيل خروج',
    sign_up: 'اشتراك',
    about_us: 'معلومات عنا',
    contact_us: 'اتصل بنا',
    payments_list: 'قائمة المدفوعات',
  },

  contact: {
    name_required: 'مطلوب اسم',
    only_alphabets: 'يسمح فقط الحروف الهجائية لهذا المجال',
    more_characters: 'لا يمكن أن يزيد الاسم عن 20 حرفًا.',
    valid: 'يجب أن يكون البريد الإلكتروني صالحًا',
    subject: 'الموضوع مطلوب',
    subject_max: 'لا يمكن أن يزيد الموضوع عن 30 حرفًا.',
    message: 'الرسالة مطلوبة ',
    message_min: 'يجب ألا يقل طول الرسالة عن 40 حرفًا.',
    message_max: 'لا يمكن أن تزيد الرسالة عن 250 حرفًا.',
  },

  descriptions: {
    seo_setting: 'إعدادات تحسين محركات البحث',
    update_checkout: 'التحديث والاستمرار في الخروج الذهبي',
    plans_management: 'إدارة الخطط',
    create_plan: 'إنشاء خطة',
    fill: 'املأ تفاصيل الفواتير الخاصة بك',
    handling:
      'نطلب تفاصيل الفواتير الخاصة بك لإنشاء فواتير مناسبة وللتعامل مع الضرائب ، قم بتقديم تفاصيل فواتير صالحة فقط.',
    no_account: 'ليس لديك حساب؟',
    leave_empty: '.اتركه فارغا للحصول على واحد عشوائي',
    do_everything: 'فعل كل شيء',
    with_one: 'مع واحد',
    platform: 'برنامج',
    shorten_urls:
      '.قم بتقصير عناوين URL وإنشاء صفحات الارتباط الحيوي ورموز QR المخصصة وروابط vcard وروابط الملفات والمزيد',
    get_started: 'البدء',
    create_own: '.قم بإنشاء صفحة الارتباط الحيوي الفريدة والقابلة للتخصيص بدرجة كبيرة بسهولة',
    custom_colors: 'ألوان وعلامات تجارية مخصصة',
    ready_to_use: 'مكونات متعددة جاهزة للاستخدام',
    protection: 'حماية كلمة المرور ، تحذير المحتوى الحساس',
    shortened_links: 'روابط مختصرة',
    service: 'نعم! يمكنك استخدام خدمتنا كمقصّر أيضًا.',
    demographic: 'استهداف البلد والجهاز واللغة',
    scheduling: 'الجدولة وحدود انتهاء الصلاحية',
    ab_rotation: 'دوران أ / ب',
    password: 'حماية كلمة المرور ، تحذير المحتوى الحساس',
    fully_featured: '.نظام مولد رمز الاستجابة السريعة متميز تمامًا مع قوالب سهلة الاستخدام',
    built_in: 'تحليلات مدمجة',
    day_by: '.التحليلات اليومية والإحالات والبلدان وأنظمة التشغيل واللغات وغيرها الكثير',
    generate_links: '.إنشاء روابط ديناميكية للملفات والاستفادة من ميزات التتبع والحماية والبكسل وانتهاء الصلاحية',
    generate_vcard:
      '.إنشاء روابط vcard ديناميكية لبطاقة جهة الاتصال القابلة للتنزيل والاستفادة من التتبع ، ميزات الحماية والبكسل وانتهاء الصلاحية',
    offering: '.نقدم لك أيضًا مجموعة من 35 من أدوات الويب المفيدة كمكافأة',
    connect: 'قم بتوصيل المجال الخاص بك أو استخدم المجالات المحددة مسبقًا الخاصة بنا',
    easiest_way: '.أسهل طريقة لتصنيف الموارد المدارة الخاصة بك',
    choose_yourself: '.اختر واحصل على ما تحتاجه بالضبط',
    feel_free: 'لا تتردد في الاتصال بنا',
    enter_message: '.أدخل رسالتك هنا',
    add_new: 'إضافة كتلة جديدة',
    add_link: 'أضف زر ارتباط',
    add_heading: 'أضف عنوانًا',
    add_tweet: 'أضف تغريدة',
    add_avatar: 'أضف الصورة الرمزية',
    add_social: 'أضف الروابط الاجتماعية',
    choose_custom_plan: 'ابدأ الخطة الذهبية',
    almost_there: 'أنت على وشك الوصول إلى هناك ، بدون قيود.',
    trial_start: 'ابدأ الإصدار التجريبي لمدة 7 أيام',
    skip_trial: 'تخطي التجربة',
    trial_info:
      'من خلال الاستمرار في طلبك ، فإنك تؤكد أنك قرأت وفهمت ووافقت على الشروط والأحكام وسياسة الخصوصية الخاصة بالموقع.',
    terms: 'الأحكام والشروط',
    add_image: 'أضف صورة',
    img_description: '.وصف الصورة لأغراض الوصول وتحسين محركات البحث',
    add_youtube: 'أضف فيديو يوتيوب',
    paste_video_url: '.الصق عنوان URL لفيديو YouTube الخاص بك وسنعرضه كفيديو في ملفك الشخصي',
    add_tiktok: 'أضف فيديو TikTok',
    paste_tiktok: '.الصق عنوان URL لفيديو TikTok وسنعرضه كفيديو في ملفك الشخصي',
    tiktok_url: 'رابط فيديو TikTok',
    valid_email: 'يجب أن يكون البريد الإلكتروني عنوان بريد إلكتروني صالحًا',
    email_required: 'البريد الالكتروني مطلوب',
    password_required: 'كلمة المرور مطلوبة',
    name_required: 'مطلوب اسم',
    user_name_required: 'اسم المستخدم مطلوب',
    firstName_required: 'الإسم الأول مطلوب',
    enter_email:
      '.يرجى إدخال عنوان البريد الإلكتروني المرتبط بحسابك وسنرسل لك عبر البريد الإلكتروني رابطًا لإعادة تعيين كلمه السر',
    already_account: 'هل لديك حساب؟',
    drag_drop: 'اسحب وأفلت لإعادة الترتيب',
    can_confirm: 'أؤكد أنني قد قرأت وفهمت',
    of_site: '.من الجانب',
    confirm_password: 'تأكيد كلمة المرور الجديدة',
    confirm_new: 'تأكيد كلمة المرور مطلوب',
    least_characters: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل',
    must_match: 'يجب ان تتطابق كلمات المرور',
    check_email: 'من فضلك تفقد بريدك الالكتروني!',
    sent_code:
      'لقد أرسلنا عبر البريد الإلكتروني رمز تأكيد مكونًا من 6 أرقام إلى acb @ domain ، يرجى إدخال الرمز في المربع أدناه للتحقق من البريد الإلكتروني',
    no_code: 'ليس لديك رمز؟',
    code_required: 'الرمز مطلوب',
    checking_email: 'التحقق من البريد الإلكتروني للمستخدم',
    set_2fa: 'إعداد المصادقة الثنائية',
    monthly_payment: 'مدفوعات شهرية',
    field_required: ' حقل مطلوب',
    entered_url: 'عنوان URL الذي أدخلته غير صالح للتضمين',
    golden_plan: 'الخطة الذهبية',
    plan_detail: 'لقد أوشكت على الانتهاء ، أكمل النموذج التالي وقم بتسجيل الخروج.',
    payment_frequency: 'تكرار دفع',
    annual_payments: 'المدفوعات السنوية',
    lifetime_deal: 'صفقة مدى الحياة',
    payment_method: 'طريقة الدفع او السداد',
    payment_method_stripe: 'الدفع عن طريق قطاع',
    scan_qr:
      'إذا كنت ترغب في تنشيط المصادقة الثنائية ، امسح رمز الاستجابة السريعة أو أدخل المفتاح السري في تطبيق Google Authenticator وأدخل OTP أو تخطي',
    scanned: 'تحقق من بريدك الإلكتروني أو Google Authenticator بحثًا عن رمز',
    skip: 'أو تخطي',
    copy_Qr: 'انسخ المفتاح السري فهو سري',
    type_payment: 'طريقة الدفع',
    stripe: 'شريط',
    one_payment: 'دفعة لمرة واحدة',
    recurring_payment: 'دفع متكرر',
    order_summary: 'ملخص الطلب',
    plan: 'يخطط',
    golden: 'ذهبي',
    frequency: 'تكرار',
    monthly: 'شهريا',
    type: 'يكتب',
    one_time: 'مره واحده',
    paid_with: 'مدفوعة',
    pay_pal: 'باي بال',
    price: 'سعر',
    code_redeemable: 'لدي رمز خصم / قابل للاسترداد',
    code: 'شفرة',
    total: 'المجموع',
    checkout: 'الدفع',
    day: 'كل ثلاثون يوم',
    billing: 'الفواتير',
    choosen_plan: 'الخطة المختارة',
    home: 'الصفحة الرئيسية',
    one_product: 'منتجات نهاية واحدة',
    month_update: '12 شهر التحديثات',
    month_support: '6 أشهر من الدعم',
    bio_pages: '25 صفحة بيولينك',
    bio_block: '10 كتل بيولينك',
    all_block: ' جميع كتل',
    visitors: 'الزائرين',
    page_views: 'عرض الصفحة',
    short_link: '250 روابط مختصرة',
    file_link: '2 روابط الملفات',
    vcard_link: '2 روابط ',
    qr_code: '5 رموز QR',
    proj: '50 مشروع',
    pixel: '5 بكسل',
    custom_domain: 'المجالات المخصصة',
    day_stat: '365 يومًا للاحتفاظ بالإحصاءات',
    global_domain: 'المجالات العالمية الإضافية',
    back_half: 'مخصص النصف الخلفي',
    deep_lnk: 'ربط عميق',
    removable_brand: 'العلامة التجارية القابلة للإزالة',
    custom_back: 'الخلفيات المخصصة',
    custom_col: 'ألوان العرف',
    defollow: 'حلقة الوصل اتبع',
    leap_link: 'رابط قفزة',
    seo_feature: 'ميزات تحسين محركات البحث',
    extra_font: 'خطوط اضافية',
    custome_css: 'لغة تنسيق ويب حسب الطلب',
    custom_js: 'شبيبة مخصصة',
    no_ad: 'لا اعلانات',
    api_access: 'وصول أبي ',
    showout_result: 'عرض - من 0 نتيجة.',
    user_manag: 'إدارةالمستخدم',
    user_logs: 'سجلات المستخدمين',
    user_creat: 'إنشاء مستخدم',
    user: 'المستعمل',
    status: 'حالة',
    applied_codes: 'الرموز المطبقة',
    applied_taxes: 'الضرائب المطبقة',
    detail: 'تفاصيل',
    total_amount: 'المبلغ الإجمالي',
    bulk_actions: 'إجراءات جملة',
    hidden_demo: 'مخفي في العرض',
    cant_undone: 'لا يمكن التراجع عنه.',
    login_thisuser: 'تسجيل الدخول باسم هذا المستخدم',
    loginmodal_detail1: 'بتسجيل الدخول كمستخدم آخر ، سيتم تسجيل خروجك من',
    loginmodal_detail2: 'الحساب الجاري وتسجيل الدخول بالكامل لهذا المستخدم.',
    show_result: 'عرض 1-12 من أصل 12 نتيجة.',
    add_instagram: 'أضف منشور الانستغرام',
    paste_instagram_url: 'لصق عنوان url لمنشور الانستغرام',
    delete_block_des: '.سيتم حذف جميع البيانات المتعلقة بلوك الرابط الحيوي بالكامل. لا يمكن التراجع عن هذا الإجراء',
    duplicate_block_des: '.قم بتكرار هذا المورد بسهولة بنقرة زر واحدة',
    duplicate_block: 'كتلة مكررة',
    delete_block: 'حذف الكتلة',
    add_multiple_images: 'إضافة صور متعددة',
    admin_privileges: 'سيكون للمستخدمين الإداريين نفس الامتيازات التي تتمتع بها ، كن حذرًا!',
    change_passDetail: 'اتركه فارغًا إذا كنت لا تريد تغيير كلمة مرور المستخدم!',
    new_pass: 'كلمة السر الجديدة',
    repeat_pass: 'اعد كلمة السر',
    block_search: 'منع فهرسة محرك البحث',
    block_biolink: 'منع صفحة biolink من فهرستها بواسطة محركات البحث.',
    change_page: 'قم بتغيير عنوان الصفحة تمامًا إلى عنوان مخصص تقوم بتعيينه هنا.',
    custom_meta: 'قم بتعيين وصف تعريف مخصص لصفحة biolink الخاصة بك لترتيب أفضل في محركات البحث.',
  },

  biolink_title: {
    edit: 'تعديل',
    delete: 'حذف',
    view: 'رأي',
    settings: 'إعدادات',
    duplicate: 'مكرر',
    your_link_is: 'الرابط الخاص بك هو',
    copy_to_clipboard: 'مقطع إلى الحافظة',
    copied: 'نسخ',
    change_status: 'تغيير الوضع',
    edit_user: 'تحرير العضو',
    november: 'شهر نوفمبر',
  },

  admin: {
    welcome: 'مرحبًا بعودتك',
    biolink_pages: 'صفحات Biolinks',
    pageviews_tracked: 'مرات مشاهدة الصفحة التي تم تتبعها',
  },

  label: {
    view_user: 'عرض المستخدم',
    user_id: 'معرف المستخدم',
    privileges: 'الامتيازات',
    timezone: 'وحدة زمنية',
    Factor_authentication: 'عامل_المصادقة',
    Anti_code: 'كود مكافحة التصيد',
    active: 'نشيط',
    disabled: 'عاجز',
    hidden: 'مختفي',
    english: 'الإنجليزية',
    arabic: 'عربى',
    main_language: 'اللغة الرئيسية',
    no: 'رقم',
    api_key: 'مفتاح API',
    total_logins: 'إجمالي عمليات تسجيل الدخول',
    last_useragent: 'آخر وكيل مستخدم',
    last_active: 'آخر نشاط',
    country: 'دولة',
    direct_signup: 'تسجيل مباشر',
    source: 'مصدر',
    trial_done: 'انتهت المحاكمة',
    last_subid: 'آخر معرف فرعي',
    last_payamount: 'مبلغ الدفعة الأخيرة',
    last_payprocessor: 'آخر معالج دفع',
    plan_expdate: 'تاريخ انتهاء الخطة',
    free: 'مجانا',
    update: 'تحديث',
    change_password: 'غير كلمة السر',
    enable_stripepay: 'تفعيل شريط مدفوعات ',
    publishable_key: 'مفتاح قابل للنشر',
    secret_key: 'المفتاح السري',
    webhook_secret: 'سر الويب هوك',
    webhook: 'الويب هوك',
    more_detail: 'للحصول على مزيد من التفاصيل حول بعض التكوينات المتاحة.',
    read_the: 'إقرأ ال',
    documentation: 'توثيق',
  },

  privacy_policy: 'سياسة الخصوصية',
  views: 'الآراء',
  terms_here: 'شروط الخدمة الخاصة بك تذهب هنا',
  bold: 'بالخط العريض',
  italic: 'مائل',
  underline: 'تسطير',
  policy_here: 'سياسة الخصوصية الخاصة بك اذهب هنا',
  overview: 'نظرة عامة',
  needed_docs: 'في هذه الصفحة ، يمكنك العثور على الوثائق المطلوبة لتثبيت المنتج وتكوينه بشكل كامل',
  product_installation:
    'إجراء تثبيت المنتج مستقيم للأمام ولا يتطلب أي خاص / خارج مهمة عادية. الحد الأدنى من المعرفة حول كيفية العمل مع قاعدة بيانات وإدارة الملفات على الخادم مطلوب.',
  created_on: 'تم إنشاؤها على',
  requirements: 'متطلبات',
  meet_req: 'يرجى التأكد من أن الخادم الخاص بك يفي بالمتطلبات التالية قبل محاولة التثبيت أو الشراء المنتج.',
  december: 'ديسمبر',
  payments: 'المدفوعات',
  changelog_config: 'تأكد من إعادة تكوين إعدادات خططك لتكوين المجالات الإضافية الجديدة',
  initial_release: 'الإصدار الأولي',
  changelog_detail: 'سيتم سرد كافة التحديثات الخاصة بـ Bil Bio هنا. تستند إصدارات Bil Bio إلى نظام MAJOR.MINOR.PATCH',
  get_support: 'احصل على الدعم',
  official_website: 'الموقع الرسمي',
  changelog: 'التغيير',
  docs: 'المستندات',
  read_documentation: 'اقرأ التوثيق',
  read_changelog: 'قراءة سجل التغيير',
  latest_users: 'أحدث المستخدمين',
  page_views: 'مشاهدات الصفحة',
  biolinks_pages: 'بيولينكس الصفحات',
  percent_disc: 'نسبة الخصم',
  fix_discount: 'خصم على المبلغ الثابت',
  percent_amount: 'كمية النسبة المئوية',
  duration: 'مدة',
  find_me: 'أقوم ببناء برامج عالية الجودة وجاهزة للاستخدام وبأسعار معقولة. هنا يمكنك أن تجدني:',
  twitter_bilBio: 'تويترBilBio',
  support_is: 'الدعم',
  only: 'فقط',
  done_codecanyon: 'تم القيام به من خلال Codecanyon',
  email_form: 'نموذج البريد الإلكتروني',
  comments: 'تعليقات',
  section: 'الجزء',
  once: 'ذات مرة',
  forever: 'إلى الأبد',
  repeating: 'التكرار',
  number_ofmonths: 'عدد الأشهر',
  months: 'الشهور',
  discount_amount: 'مقدار الخصم',
  availabe_plan: 'كم يوما ستكون الخطة متاحة',
  discount_plan: 'اختر خصمًا بين 1٪ و 99٪ للرمز',
  redeemable: 'قابل للاسترداد',
  install_product: 'كيف يتم تثبيت المنتج؟',
  update_product: 'كيف يتم تحديث المنتج؟',
  customize_product: 'كيفية تخصيص المنتج؟',
  edit_home: 'تحرير المنزل',
  code_usage: 'كم مرة يمكن استخدام الرمز',
  home_settings: 'إعدادات المنزل',
  about_section: 'حول إعدادات القسم',
  website_settings: 'إعدادات الموقع',
  contact_settings: 'إعدادات الاتصال',
  Biolink_Page: 'صفحة بيولينك',
  Qr_code: 'رموز QR',
  analytics: 'التحليلات',
  personal: 'شخصي',
  business: 'اعمال',
  city: 'مدينة',
  country: 'دولة',
  province: 'المحافظة',
  opengraph_image: 'فتح صورة الرسم البياني',
  page_title: 'عنوان الصفحة',
  meta_description: 'ميتا الوصف',
  zip: 'أَزِيز',
  countdown: 'العد التنازلي',
  share: 'شارك',
  resend_code: 'أعد إرسال الرمز',
  register: 'تسجيل',
  link: 'نهاية لهذه الغاية',
  instagram: 'انستغرام',
  google: 'غوغل',
  facebook: 'فيسبوك',
  telephone: 'هاتف',
  life_time: 'حياة',
  linkedin: 'ينكدين',
  pinterest: 'بينتيريست',
  twitch: 'تويتش',
  snapchat: 'سناب شات',
  spotify: 'سبوتيفي',
  twitter: 'تويتر',
  username: 'اسم االمستخدم',
  monthly: 'شهريا',
  annual: 'سنوي',
  tracking_pixels: 'بكسل التتبع',
  tool: 'أداة',
  block: 'الكتلة',
  add: 'يضيف',
  short_url: 'عنوان URL قصير',
  customization: 'التخصيص',
  image_alt: 'صورة بديلة',
  branding: 'العلامات التجارية',
  create_code: 'إنشاء كود',
  create_newCode: 'أنشئ رمزًا جديدًا',
  youtube_url: 'يوتيوب فيديو URL',
  instagram_url: 'رابط مشاركة انستغرام',
  channel: 'قناة',
  fonts: 'الخطوط',
  submit: 'إرسال',
  delete: 'حذف',
  duplicate: 'ينسخ',
  monochrome: 'أحادي اللون',
  gradient: 'الانحدار',
  destination_url: 'عنوان url المقصود',
  custom: 'العادة',
  themes: 'الموضوعات',
  background: 'معرفتي',
  simple_gradients: 'تدرجات بسيطة',
  abstract_gradients: 'تدرجات مجردة',
  custom_color: 'لون مخصص',
  color: 'اللون',
  custom_image_video: 'صورة / فيديو مخصص',
  favicon: 'فافيكون',
  maximum: 'يسمح بامتداد .png و .gif و .ico. 2 ميغا بايت كحد أقصى.',
  display: 'عرض',
  name: 'اسم',
  Unique_user_name: 'اسم مستخدم فريد',

  firstName: 'الاسم الأول',
  text_color: 'لون الخط',
  default_branding: 'اتركه فارغًا للحصول على العلامة التجارية الافتراضية للموقع.',
  size: 'بحجم',
  border_radius: 'نصف قطر الحدود',
  border_Style: 'نمط الحدود',
  total: 'المجموع',
  border_width: 'عرض الحدود',
  border_color: 'لون الحدود',
  border_style: 'نمط الحدود',
  img_thumbnail: 'صورة مصغرة',
  bg_color: 'لون الخلفية',
  biolinks: 'بيولينكس',
  biolink: 'بيولينك',
  biolink_blocks: 'كتل بيولينك',
  total_sales: 'إجمالي المبيعات',
  total_earned: 'إجمالي المكتسبة',
  links: 'الروابط',
  links_statistics: 'روابط الإحصاء',
  files: 'الملفات',
  file: 'ملف',
  statistics: 'الإحصاء',
  card: 'بطاقة',
  codes: 'رموز',
  seo: 'سيو',
  domains: 'المجالات',
  create: 'إنشاء ضريبة',
  copyright: 'حقوق النشر',
  terms_of_service: 'شروط الخدمة',
  who_are_we: 'من نحن؟',
  all_rights_reserved: 'كل الحقوق محفوظة',
  export_to: 'تصدير الى',
  filter: 'منقي',
  search: 'بحث',
  search_by: 'البحث عن طريق',
  status: 'الحالة',
  project: 'مشروع',
  type: 'يكتب',
  order_type: 'نوع الطلب',
  results_per_page: 'النتائج لكل صفحة',
  your_custom_alias: 'الاسم المستعار المخصص الخاص بك',
  mode: 'الوضع',
  contrast: 'التباين',
  direction: 'اتجاه',
  layout: 'تَخطِيط',
  presets: 'الإعدادات المسبقة',
  stretch: 'تمتد',
  fullscreen: 'شاشة كاملة',
  exit: 'خروج',
  tweet_id: 'سقسقة معرف',
  tracked_reviews: 'مرات مشاهدة الصفحة المتعقبة',
  pricing_plans: 'خطط التسعير',
  address: 'تبوك',
  phone: 'هاتف',
  send_message: 'أرسل رسالة',
  email: 'البريد الإلكتروني',
  title: 'لقب',
  subject: 'موضوعات',
  heading: 'عنوان',
  avatar: 'الصورة الرمزية',
  socials: 'الاجتماعية',
  image: 'صورة',
  youtube: 'موقع يوتيوب',
  secret_key: 'المفتاح السري',
  authenticate: 'المصادقة',
  auth_type: 'نوع المصادقة',
  time_based: 'على أساس الوقت',
  tiktok: 'تيك توك',
  destination: 'المكان المقصود',
  purchased_Plan_monthly: '.لقد اشتريت خطة شهرية',
  purchased_Plan_yearly: '.لقد اشتريت خطة سنوية.',
  purchased_Plan_lifetime: 'لقد اشتريت خطة مدى الحياة',
  enjoy_your_plan: '.يرجى الاستمتاع بخطة حياتك',
  close: 'قريب',
  want_to_update_plan_yearly_lifetime: 'هل تريد تحديث خطتك سنويًا أم مدى الحياة؟',
  want_to_update_plan_lifetime: 'هل تريد تحديث خطتك مدى الحياة؟',
  updating_plan: 'تحديث الخطة',
  text: 'نص',
  round: 'دائري',
  rounded: 'مدور',
  straight: 'مستقيم',
  and: 'و',
  or: 'أو',
  oftheSite: 'من الجانب',
  whatYouWillGet: 'ما ستحصل عليه',
  home: 'الصفحة الرئيسية',
  choose_plan: 'اختر الخطة',
  solid: 'صلب',
  dashed: 'متقطع',
  double: 'مزدوج',
  outset: 'البداية',
  inset: 'أقحم',
  infinite: 'لانهائي',
  animation: 'الرسوم المتحركة',
  animation_runs: 'تشغيل الرسوم المتحركة',
  bounce: 'وثب، ارتداد',
  tada: 'تادا',
  wobble: 'تمايل',
  swing: 'تأرجح',
  rubberband: 'رابط مطاطي',
  pulse: 'نبض',
  flash: 'فلاش',
  bounce_in: 'ترتد',
  fade_in: 'اختفي',
  small: 'صغير',
  medium: 'متوسط',
  large: 'كبير',
  email_address: 'عنوان البريد الالكترونى',
  pass: 'كلمه السر',
  forgot_password: 'هل نسيت كلمة السر؟',
  login: 'تسجيل الدخول',
  remember_me: 'تذكرنى',
  faq: 'التعليمات',
  social: 'تناسلي',
  send_request: 'ارسل طلب',
  back: 'الى الخلف',
  dashboard: 'لوحة القيادة',
  plans: 'الخطط',
  taxes: 'الضرائب',

  languages: 'اللغات',
  language_code: 'رمز اللغة',
  powered_by: 'مشغل بواسطة',
  verify: 'تحقق',
  divider: 'مقسم',
  add_divider: 'إضافة مقسم',
  image_grid: 'شبكة الصورة',
  yes: 'نعم',
  janurary: 'كانون الثاني',
  feb: 'شهر فبراير',
  codes_management: 'إدارة الرموز',
  create_tax: 'إنشاء ضريبة',
  redeemed: 'افتدى',
  quantity: 'كمية',
  discount: 'تخفيض',
  tax: 'ضريبة',
  billing_for: 'الفواتير ل',
  taxes_management: 'إدارة الضرائب',
  random_discription: 'وصف عشوائي لرسوم الدعم.',
  personal_business: 'الشخصية والتجارية',
  exclusive: 'حصرية',
  support_fee: 'رسوم الدعم',
  call_to_action: 'دعوة للعمل',
  language: 'لغة',
  extensions: 'ملحقات',
  database: 'قاعدة البيانات',
  server: 'الخادم',
  other_extentions:
    'ضع في اعتبارك ، قد تكون هناك حاجة لملحقات أخرى غير تلك المذكورة هنا ، مثل هذه تفترض المتطلبات أنك تعمل على خادم لائق ومحدث يجب أن يحتوي على الأساسيات المطلوبة ملحقات تعمل بالفعل.',
  users: 'المستخدمين',
  add_plan: 'أضف خطة',
  interval_count: 'عدد الفترات',
  interval: 'فترة',
  trial_days: 'أيام المحاكمة',
  year: 'سنة',
  month: 'شهر',
  user_id: 'معرف المستخدم',
  currency: 'عملة',

  countries: {
    afghanistan: '🇦🇫 أفغانستان',
    aland_islands: '🇦🇽 جزر آلاند',
    albania: '🇦🇱 ألبانيا',
    algeria: '🇩🇿 الجزائر',
    american_samoa: '🇦🇸 ساموا الأمريكية',
    andorra: '🇦🇩 أندورا',
    angola: '🇦🇴 أنغولا',
    anguilla: '🇦🇮 أنغيلا',
    antarctica: '🇦🇶 القارة القطبية الجنوبية',
    antigua_barbuda: '🇦🇬 أنتيغوا وبربودا',
    argentina: '🇦🇷 الأرجنتين',
    armenia: '🇦🇲 أرمينيا',
    aruba: '🇦🇼 أروبا',
    australia: '🇦🇺 استراليا',
    austria: '🇦🇹 النمسا',
    azerbaijan: '🇦🇿 أذربيجان',
    bahamas: '🇧🇸 جزر البهاما',
    bahrain: '🇧🇭 البحرين',
    bangladesh: '🇧🇩 بنجلاديش',
    barbados: '🇧🇧 بربادوس',
    belarus: '🇧🇾 بيلاروسيا',
    belgium: '🇧🇪 بلجيكا',
    belize: '🇧🇿 بليز',
    benin: '🇧🇯 بنين',
    bermuda: '🇧🇲 برمودا',
    bhutan: '🇧🇹 بوتان',
    bolivia: '🇧🇴 بوليفيا',
    eustatius_saba: '🇧🇶 بونير وسانت يوستاتيوس وسابا',
    bosnia_herzegovina: '🇧🇦 البوسنة والهرسك',
    botswana: '🇧🇼 بوتسوانا',
    bouvet_island: '🇧🇻 جزيرة بوفيت',
    brazil: '🇧🇷 البرازيل',
    british_indian: '🇮🇴 إقليم المحيط الهندي البريطاني',
    brunei_darussalam: '🇧🇳 بروناي دار السلام',
    bulgaria: '🇧🇬 بلغاريا',
    burkina_faso: '🇧🇫 بوركينا فاسو',
    burundi: '🇧🇮 بوروندي',
    cambodia: '🇰🇭 كمبوديا',
    cameroon: '🇨🇲 الكاميرون',
    canada: '🇨🇦 كندا',
    cape_verde: '🇨🇻 الرأس الأخضر',
    cayman_islands: '🇰🇾 جزر كايمان',
    central_african: '🇨🇫 جمهورية إفريقيا الوسطى',
    chad: '🇹🇩 تشاد',
    chile: '🇨🇱 تشيلي',
    china: '🇨🇳 الصين',
    christmas_island: '🇨🇽 جزيرة الكريسماس',
    cocos_islands: '🇨🇨 جزر كوكوس (كيلينغ)',
    colombia: '🇨🇴 كولومبيا',
    comoros: '🇰🇲 جزر القمر',
    congo: '🇨🇬 الكونغو',
    democratic_republic: '🇨🇩 الكونغو ، جمهورية الكونغو الديمقراطية',
    cook_islands: '🇨🇰 جزر كوك',
    costa_rica: '🇨🇷 كوستاريكا',
    cote_ivoire: '🇨🇮 ساحل العاج',
    croatia: '🇭🇷 كرواتيا',
    cuba: '🇨🇺 كوبا',
    curacao: '🇨🇼 كوراكاو',
    cyprus: '🇨🇾 قبرص',
    czech_republic: '🇨🇿 جمهورية التشيك',
    denmark: '🇩🇰 الدنمارك',
    djibouti: '🇩🇯 جيبوتي',
    dominica: '🇩🇲 دومينيكا',
    dominican_republic: '🇩🇴 جمهورية الدومينيكان',
    ecuador: '🇪🇨 الاكوادور',
    egypt: '🇪🇬 مصر',
    el_salvador: '🇸🇻 السلفادور',
    equatorial_guinea: '🇬🇶 غينيا الاستوائية',
    eritrea: '🇪🇷 إريتريا',
    estonia: '🇪🇪 استونيا',
    ethiopia: '🇪🇹 إثيوبيا',
    falkland_islands: '🇫🇰 جزر فوكلاند (مالفيناس)',
    faroe_islands: '🇫🇴 جزر فارو',
    fiji: '🇫🇯 فيجي',
    finland: '🇫🇮 فنلندا',
    france: '🇫🇷 فرنسا',
    french_guiana: '🇬🇫 غيانا الفرنسية',
    french_polynesia: '🇵🇫 بولينيزيا الفرنسية',
    southern_territories: '🇹🇫 الأقاليم الجنوبية الفرنسية',
    gabon: '🇬🇦 الجابون',
    gambia: '🇬🇲 غامبيا',
    georgia: '🇬🇪 جورجيا',
    germany: '🇩🇪 ألمانيا',
    ghana: '🇬🇭 غانا',
    gibraltar: '🇬🇮 جبل طارق',
    greece: '🇬🇷 اليونان',
    greenland: '🇬🇱 جرينلاند',
    grenada: '🇬🇩 غرينادا',
    guadeloupe: '🇬🇵 جوادلوب',
    guam: '🇬🇺 غوام',
    guatemala: '🇬🇹 غواتيمالا',
    guernsey: '🇬🇬 جيرنزي',
    guinea: '🇬🇳 غينيا',
    guinea_bissau: '🇬🇼 غينيا بيساو',
    guyana: '🇬🇾 غيانا',
    haiti: '🇭🇹 هايتي',
    heard_island: '🇭🇲 جزيرة هيرد وجزر ماكدونالد',
    holy_see: '🇻🇦 الكرسي الرسولي (دولة الفاتيكان)',
    honduras: '🇭🇳 هندوراس',
    hong_kong: '🇭🇰 هونج كونج',
    hungary: '🇭🇺 المجر',
    iceland: '🇮🇸 آيسلندا',
    india: '🇮🇳 الهند',
    indonesia: '🇮🇩 اندونيسيا',
    iran_islamic: '🇮🇷 إيران ، جمهورية - الإسلامية',
    iraq: '🇮🇶 العراق',
    ireland: '🇮🇪 أيرلندا',
    isle_man: '🇮🇲 جزيرة مان',
    israel: '🇮🇱 إسرائيل',
    italy: '🇮🇹 ايطاليا',
    jamaica: '🇯🇲 جامايكا',
    japan: '🇯🇵 اليابان',
    jersey: '🇯🇪 جيرسي',
    jordan: '🇯🇴 الاردن',
    kazakhstan: '🇰🇿 كازاخستان',
    kenya: '🇰🇪 كينيا',
    kiribati: '🇰🇮 كيريباتي',
    korea_democratic: '🇰🇵 جمهورية كوريا الديمقراطية الشعبية',
    korea_republic: '🇰🇷 جمهورية كوريا',
    kosovo: '🇽🇰 كوسوفو',
    kuwait: '🇰🇼 الكويت',
    kyrgyzstan: '🇰🇬 قيرغيزستان',
    lao_people: '🇱🇦 جمهورية لاو الديمقراطية الشعبية',
    latvia: '🇱🇻 لاتفيا',
    lebanon: '🇱🇧 لبنان',
    lesotho: '🇱🇸 ليسوتو',
    liberia: '🇱🇷 ليبيريا',
    libyan_arab: '🇱🇾 الجماهيرية العربية الليبية',
    liechtenstein: '🇱🇮 ليختنشتاين',
    lithuania: '🇱🇹 ليتوانيا',
    luxembourg: '🇱🇺 لوكسمبورغ',
    macao: '🇲🇴 ماكاو',
    macedonia_former: '^ مقدونيا ، جمهورية يوغوسلافيا السابقة',
    madagascar: '🇲🇬 مدغشقر',
    malawi: '🇲🇼 ملاوي',
    malaysia: '🇲🇾 ماليزيا',
    maldives: '🇲🇻 جزر المالديف',
    mali: '🇲🇱 مالي',
    malta: '🇲🇹 مالطا',
    marshall_islands: '🇲🇭 جزر مارشال',
    martinique: '🇲🇶 مارتينيك',
    mauritania: '🇲🇷 موريتانيا',
    mauritius: '🇲🇺 موريشيوس',
    mayotte: '🇾🇹 مايوت',
    mexico: '🇲🇽 المكسيك',
    micronesia_federated: '🇫🇲 ولايات ميكرونيزيا الموحدة',
    moldova_republic: '🇲🇩 مولدوفا ، جمهورية',
    monaco: '🇲🇨 موناكو',
    mongolia: '🇲🇳 منغوليا',
    montenegro: '🇲🇪 الجبل الأسود',
    montserrat: '🇲🇸 مونتسيرات',
    morocco: '🇲🇦 المغرب',
    mozambique: '🇲🇿 موزمبيق',
    myanmar: '🇲🇲 ميانمار',
    namibia: '🇳🇦 ناميبيا',
    nauru: '🇳🇷 ناورو',
    nepal: '🇳🇵 نيبال',
    netherlands: '🇳🇱 هولندا',
    netherlands_antilles: '🇦🇳 جزر الأنتيل الهولندية',
    new_caledonia: '🇳🇨 كاليدونيا الجديدة',
    new_zealand: '🇳🇿 نيوزيلندا',
    nicaragua: '🇳🇮 نيكاراغوا',
    niger: '🇳🇪 النيجر',
    nigeria: '🇳🇬 نيجيريا',
    niue: '🇳🇺 نيوي',
    norfolk_island: '🇳🇫 جزيرة نورفولك',
    northern_mariana: '🇲🇵 جزر ماريانا الشمالية',
    norway: '🇳🇴 النرويج',
    oman: '🇴🇲 عمان',
    pakistan: '🇵🇰 باكستان',
    palau: '🇵🇼 بالاو',
    palestinian_territory: '🇵🇸 الأراضي الفلسطينية المحتلة',
    panama: '🇵🇦 بنما',
    papua_new: '🇵🇬 بابوا غينيا الجديدة',
    paraguay: '🇵🇾 باراغواي',
    peru: '🇵🇪 بيرو',
    philippines: '🇵🇭 الفلبين',
    pitcairn: '🇵🇳 بيتكيرن',
    poland: '🇵🇱 بولندا',
    portugal: '🇵🇹 البرتغال',
    puerto_rico: '🇵🇷 بورتوريكو',
    qatar: '🇶🇦 قطر',
    reunion: '🇷🇪 ريونيون',
    romania: '🇷🇴 رومانيا',
    russian_federation: '🇷🇺 الاتحاد الروسي',
    rwanda: '🇷🇼 رواندا',
    saint_barthelemy: '🇧🇱 القديس بارتيليمي',
    saint_helena: '🇸🇭 سانت هيلانة',
    saint_kitts: '🇰🇳 سانت كيتس ونيفيس',
    saint_lucia: '🇱🇨 سانت لوسيا',
    saint_martin: '🇲🇫 سانت مارتن',
    saint_pierre: '🇵🇲 سان بيير وميكلون',
    saint_vincent: '🇻🇨 سانت فنسنت وجزر غرينادين',
    samoa: '🇼🇸 ساموا',
    san_marino: '🇸🇲 سان مارينو',
    sao_tome: '🇸🇹 ساو تومي وبرينسيبي',
    saudi_arabia: '🇸🇦 السعودية',
    senegal: '🇸🇳 السنغال',
    serbia: '🇷🇸 صربيا',
    serbia_montenegro: '🇨🇸 صربيا والجبل الأسود',
    seychelles: '🇸🇨 سيشيل',
    sierra_leone: '🇸🇱 سيراليون',
    singapore: '🇸🇬 سنغافورة',
    sint_maarten: '🇸🇽 سينت مارتن',
    slovakia: '🇸🇰 سلوفاكيا',
    slovenia: '🇸🇮 سلوفينيا',
    solomon_islands: '🇸🇧 جزر سليمان',
    somalia: '🇸🇴 الصومال',
    south_africa: '🇿🇦 جنوب افريقيا',
    south_georgia: '🇬🇸 جورجيا الجنوبية وجزر ساندويتش الجنوبية',
    south_sudan: '🇸🇸 جنوب السودان',
    spain: '🇪🇸 اسبانيا',
    sri_lanka: '🇱🇰 سري لانكا',
    sudan: '🇸🇩 السودان',
    suriname: '🇸🇷 سورينام',
    svalbard_jan: '🇸🇯 سفالبارد وجان ماين',
    swaziland: '🇸🇿 سوازيلاند',
    sweden: '🇸🇪 السويد',
    switzerland: '🇨🇭 سويسرا',
    syrian_arab: '🇸🇾 الجمهورية العربية السورية',
    taiwan_province: '🇹🇼 تايوان ، مقاطعة الصين',
    tajikistan: '🇹🇯 طاجيكستان',
    tanzania_united: '🇹🇿 جمهورية تنزانيا المتحدة',
    thailand: '🇹🇭 تايلاند',
    timor_leste: '🇹🇱 تيمور الشرقية',
    togo: '🇹🇬 توغو',
    tokelau: '🇹🇰 توكيلاو',
    tonga: '🇹🇴 تونغا',
    trinidad_tobago: '🇹🇹 ترينيداد وتوباغو',
    tunisia: '🇹🇳 تونس',
    turkey: '🇹🇷 تركيا',
    turkmenistan: '🇹🇲 تركمانستان',
    turks_caicos: '🇹🇨 جزر تركس وكايكوس',
    tuvalu: '🇹🇻 توفالو',
    uganda: '🇺🇬 أوغندا',
    ukraine: '🇺🇦 أوكرانيا',
    united_arab: '🇦🇪 الإمارات العربية المتحدة',
    united_kingdom: '🇬🇧 المملكة المتحدة',
    united_states: '🇺🇸 الولايات المتحدة',
    unitedStates_minor: '🇺🇲 جزر الولايات المتحدة البعيدة الصغيرة',
    uruguay: '🇺🇾 أوروغواي',
    uzbekistan: '🇺🇿 أوزبكستان',
    vanuatu: '🇻🇺 فانواتو',
    venezuela: '🇻🇪 فنزويلا',
    viet_nam: '🇻🇳 فيتنام',
    virgin_islands: '🇻🇬 جزر فيرجن البريطانية',
    islands_us: '🇻🇮 جزر فيرجن ، الولايات المتحدة.',
    wallis_futuna: '🇼🇫 واليس وفوتونا',
    western_sahara: '🇪🇭 الصحراء الغربية',
    yemen: '🇾🇪 اليمن',
    zambia: '🇿🇲 زامبيا',
    zimbabwe: '🇿🇼 زيمبابوي',
  },

  miscellaneous: {
    tweel_url: 'إضافة رابط تغريدة',
    divider: ' ',
    add_share: 'إضافة كتلة حصة',
    add_countdown: 'أضف مؤقتًا للعد التنازلي',
    date_time: 'التاريخ والوقت',
    add_action: 'أضف العمل',
    add_faq: 'أضف الأسئلة المتداولة',
    email_me: 'راسلني',
    bulk_generator: 'مولد بالجملة',
  },

  edit_taxes: {
    create_new: 'إنشاء ضريبة جديدة',
    created_tax: 'بمجرد إنشاء ضريبة ، لا يمكن تعديلها أو حذفها. بعد إنشاء الضريبة ، يمكنك إقرانها بخططك التي أنشأتها.',
    percentage: 'نسبة مئوية',
    taxes: 'الضرائب',
    edittax: 'تحرير الضريبة',
    edit: 'يحرر',
    description: 'وصف',
    tax_value: 'قيمة الضريبة',
    value_type: 'نوع القيمة',
    fixed: 'مُثَبَّت',
    inclusive: 'شامل',
    exclusive: 'حصرية',
    personal_only: 'شخصي فقط',
    business_only: 'العمل فقط',
    personal_business: 'عمل شخصي',
    billing_for: 'الفواتير ل',
    countries: 'بلدان',
    select: 'حدد البلدان التي تريد تطبيق هذه الضريبة عليها. اتركه فارغًا إذا كنت تريد تطبيق الضريبة على جميع البلدان.',
  },

  planss: {
    edit_plan: 'تحرير الخطة',
    plan_features: 'ميزات الخطة',
    set: 'تعيين',
    for_unlimited: 'تعيين -1 لعدد غير محدود',
    total_amoutpage: 'العدد الإجمالي لصفحات الارتباط البيولوجي التي يمكن للمستخدم إنشاؤها.',
    total_shortlink: 'العدد الإجمالي للروابط المختصرة التي يمكن للمستخدم إنشاؤها.',
    total_filelink: 'المقدار الإجمالي لارتباطات الملفات التي يمكن للمستخدم إنشاؤها.',
    vcard_Limit: 'Vcard حد الروابط',
    totl_vcard: 'العدد الإجمالي لروابط vcard التي يمكن للمستخدم إنشاؤها.',
    total_eventlinks: 'العدد الإجمالي لروابط الأحداث التي يمكن للمستخدم إنشاؤها.',
    total_domain: 'المبلغ الإجمالي للمجالات المخصصة التي يمكن للمستخدم إضافتها.',
    link_state: 'كم يوما سيتم الاحتفاظ بإحصائيات الروابط في قاعدة البيانات.',
    enable_blocks: 'كتل Biolink الممكّنة',
    select_blocks: 'حدد كتل صفحات biolink التي تم تمكينها للاستخدام في هذه الخطة.',
    state_retention: 'الاحتفاظ بإحصائيات الروابط (أيام)',
    custom_domain: 'حد المجالات المخصصة',
    event_limit: 'روابط الأحداث الحد',
    file_limit: 'حد روابط الملفات',
    link_limit: 'حد الروابط',
    blocks_limit: 'كتل Biolink لكل صفحة biolink حد',
    biolink_limit: 'حدود Biolinks',
    qr_limit: 'حدود رموز QR',
    pixels_limits: 'حدود البكسل',
    project_limits: 'حدود المشروع',
    additional_block: 'المجالات العالمية الإضافية',
    additional_blockDes:
      'سيؤدي تمكين هذا إلى جعل جميع الأشخاص الذين لديهم هذه الخطة قادرين على استخدام جميع المجالات العالمية الإضافية.',
    back_half: 'نصف خلفي مخصص',
    back_halfDes:
      'سيؤدي تمكين هذا إلى منح المستخدمين القدرة على الحصول على عناوين URL مستعارة مخصصة بدلاً من تلك التي يتم إنشاؤها تلقائيًا.',
    deep_link: 'روابط عميقة',
    deep_linkDes:
      'سيؤدي تمكين هذا إلى منح المستخدم القدرة على استخدام روابط عميقة للإشارة إلى تطبيقات معينة بدلاً من عناوين URL http و https فقط.',
    enable_ad: 'سيؤدي تمكين هذا إلى جعل جميع الأشخاص الذين لديهم هذه الخطة لا يرون أي إعلانات',
    remove_brand: 'العلامة التجارية للتذييل القابل للإزالة',
    remove_brandDes: 'يمنح هذا الخيار للأشخاص لإزالة العلامة التجارية من تذييل الروابط البيولوجية.',
    button_url: 'عنوان URL لزر الاتصال',
    description: 'عنوان URL لزر الاتصال',
    phone_collector: 'جامع الهاتف',
    email_collector: 'جامع البريد الإلكتروني',
    paragraph: 'فقرة',
    custom_branding: 'العلامة التجارية المخصصة للتذييل',
    custom_brandingDes: 'يمنح هذا الخيار للأشخاص لإضافة علامتهم التجارية المخصصة لتذييل الروابط البيولوجية.',
    colored_links: 'روابط ملونة',
    colored_linksDes: 'يمنح المستخدم القدرة على تخصيص لون روابطه البيولوجية',
    advanced_statistics: 'إحصائيات متقدمة',
    check_stat: 'يمنح المستخدم القدرة على التحقق من إحصائيات العمق واختيار الإطار الزمني ',
    custom_backgrounds: 'الخلفيات المخصصة',
    custom_backgroundDes:
      'يمنح المستخدم القدرة على إضافة خلفيات مخصصة على صفحات الروابط البيولوجية الخاصة بهم (الألوان والتدرجات والصور الفعلية).',
    temporary_URL: 'URL مؤقت',
    temporary_urlDes: 'يمنح المستخدم القدرة على جدولة الروابط والحد من النقرات.',
    seo_des: 'يمنح المستخدم القدرة على تغيير العنوان والوصف التعريفي لصفحات Biolink',
    utm_des: 'يمنح المستخدم القدرة على تعيين معلمات UTM العالمية لجميع الروابط داخل صفحة Biolink.',
    fonts_des: 'يمنح المستخدم القدرة على اختيار الخط الذي يرضيه من قائمة الخطوط الإضافية.',
    password_protection: 'حماية كلمة المرور',
    password_protectionDes: 'يمنح المستخدم القدرة على حماية روابطهم بكلمة مرور.',
    sensitive_content: 'تحذير بشأن المحتوى الحساس',
    sensitive_contentDes: 'يمنح المستخدم القدرة على تمكين تحذير المحتوى الحساس على الروابط الخاصة بهم.',
    leap_linkDes: 'يمنح المستخدم القدرة على إعادة توجيه صفحات الارتباط البيولوجي مؤقتًا إلى عنوان URL معين.',
    dofollow_link: 'Dofollow روابط biolink',
    dofollow_linkDes: 'سيكون لروابط المستخدم biolink خاصية dofollow ، وإلا فسيتم تعيينها على nofollow افتراضيًا.',
    rest_api: 'تمكين قدرة المستخدم على استخدام REST API.',
    customcss_des:
      'تمكين القدرة على إضافة css مخصص لكل صفحة biolink. كن على علم للسماح للأشخاص الموثوق بهم فقط باستخدام هذه الميزة.',
    customjs_des:
      'تمكين القدرة على إضافة js مخصصة لكل vcard. كن على علم للسماح للأشخاص الموثوق بهم فقط باستخدام هذه الميزة.',
    product_name: 'اسم المنتج',
    order: 'ترتيب',
    plan_name: 'اسم الخطة',
    action: 'عمل',
  },

  filtermodal: {
    all: 'الجميع',
    unconfirmed: 'غير مؤكد',
    admin_created: 'تم إنشاء المسؤول',
    admin_api: 'تم إنشاء واجهة برمجة تطبيقات المشرف',
    facebook_login: 'تسجيل الدخول الى الفيسبوك',
    twitter_login: 'تويتر تسجيل الدخول',
    discord_login: 'تسجيل الدخول على الفتنة',
    google_login: 'تسجيل الدخول إلى Google',
    registration_date: 'تاريخ التسجيل',
    ascending: 'تصاعدي',
    descending: 'تنازلي',
    ten: '٢',
    twentyfive: '٣',
    fifty: '٥',
    hundred: '٧',
    twohundred: '١٠',
    fivehundred: '٢٠',
    filters: 'المرشحات',
    order_by: 'ترتيب حسب',
    results_page: 'النتائج لكل صفحة',
    created_datetime: 'تاريخ الإنشاء',
    redeemable: 'قابل للاسترداد',
    dayss: 'أيام',
    external_payment: 'معرف الدفع الخارجي',
    paid: 'مدفوع',
    pending: 'قيد الانتظار',
    offline_payment: 'الدفع دون اتصال بالإنترنت',
    coinbase: 'كوين بيس',
    payU: 'PayU',
    paystack: 'Paystack',
    razorpay: 'رازورباي',
    mollie: 'مولي',
    yookassa: 'يوكاسا',
    crypto: 'Crypto.com',
    paddle: 'مجداف',
    monthly_payments: 'مدفوعات شهرية',
    missing_translation: 'الترجمة المفقودة: admin_payments.filters.order_by_name',
    missing_translate: 'الترجمة المفقودة: admin_payments.filters.order_by_email',
  },
};

export default ar;
